export default __webpack_public_path__ + "static/media/img_summary_01.8ed10dc1.png";